import { createContext, useContext, useEffect, useState } from "react";
import api, { setStoredToken, clearSessionExpired } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = logged in

  useEffect(() => {
    api
      .get("/auth/me")
      .then((r) => { setUser(r.data); api.get("/auth/csrf").catch(() => {}); })
      .catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    clearSessionExpired();
    setStoredToken(data.access_token);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      console.warn("Logout request failed; clearing local session anyway", e);
    }
    setStoredToken(null);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
